<div class="house-widget glass-container">
    <div class="widget-header">
        <ng-content select="[widget-title]"></ng-content>
    </div>
    <div class="widget-body">
        <ng-content></ng-content>
    </div>
    <div class="widget-footer" *ngIf="false">
        <ng-content select="[widget-footer]"></ng-content>
    </div>
    <!-- optional corner badge/content -->
    <ng-content select="[widget-badge]"></ng-content>
    <!-- optional overlay slot -->
    <ng-content select="[widget-overlay]"></ng-content>
    <!-- optional actions slot -->
    <ng-content select="[widget-actions]"></ng-content>
</div>
